import styled from "styled-components";

export const HeroSection = styled.section`
  height: 100vh;
  display: flex;
  align-items: center;
  padding: 100px 0;
  position: relative;

  .mynameis {
    font-family: "Fira Mono", monospace;
    color: var(--green);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    margin: 0 0 20px 2px;
    display: block;
  }

  h1,
  h2 {
    font-size: clamp(2.5rem, 6vw, 3rem);
    margin-bottom: 0;
  }

  h2 {
    font-size: clamp(2.5rem, 5.5vw, 2.8rem);
    color: var(--slate);
    line-height: 1.1;
  }

  p {
    margin-top: 20px;
  }

  a {
    margin-top: 1rem;
    color: var(--green);
    background-color: transparent;
    border: 1px solid var(--green);
    border-radius: var(--border-radius);
    padding: 1.25rem 1.75rem;
    font-size: var(--fz-sm);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    cursor: pointer;
    transition: var(--transition);
    display: inline-block;

    &:hover {
      background-color: var(--green-tint);
    }
  }

  .scroller {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 3rem;
    width: 30px;
    height: 45px;

    a {
      position: absolute;
      padding: 0;
      height: 100%;
      width: 100%;
      top: 0;
      left: 50%;
      margin-left: -15px;
      border: 2px solid var(--green);
      border-radius: 50px;
      box-sizing: border-box;

      &::before {
        position: absolute;
        top: 10px;
        left: 50%;
        content: '';
        width: 6px;
        height: 6px;
        margin-left: -3px;
        background-color: var(--green);
        border-radius: 100%;
        -webkit-animation: sdb10 2s infinite;
        animation: sdb10 2s infinite;
        box-sizing: border-box;
      }
    }

    @keyframes sdb10 {
      0% {
        transform: translate(0, 0);
        opacity: 0;
      }
      40% {
        opacity: 1;
      }
      80% {
        transform: translate(0, 15px);
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }
  }
`;
